import { render, staticRenderFns } from "./MyNFT.vue?vue&type=template&id=3986ade8&scoped=true"
import script from "./MyNFT.vue?vue&type=script&lang=js"
export * from "./MyNFT.vue?vue&type=script&lang=js"
import style0 from "./MyNFT.vue?vue&type=style&index=0&id=3986ade8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986ade8",
  null
  
)

export default component.exports